import * as types from '../mutation-types'
import  { getManagers } from '@/api/auth';


export const state = {

    loading_admin: false,
    managers: [],
    manager: {},
}

export const getters = {
    loading_admin: state => state.loading_admin,
    managers: state => state.managers,
    manager: state => state.manager,
}

export const mutations = {
    [ types.MANAGERS] (state, payload) {
        state.loading_admin = true;
    },
    [ types.MANAGERS_SUCCESS] (state, payload) {
        state.loading_admin= false;
        state.managers = payload.data;
    },
    [ types.MANAGERS_FAIL] (state, payload) {
        state.loading_admin= false;
        state.managers = [];
    },
}
export const actions = {
    async get_managers ({ commit }, payload) {
        // console.log(payload)
        commit(types.MANAGERS)
        try {
            const response = await getManagers(payload);
            commit(types.MANAGERS_SUCCESS, response);
        } catch (error) {
            console.log(error)
            commit(types.MANAGERS_FAIL);
        }
    },


}
